import { Navigate } from 'react-router-dom';

export const SecretSantaListPage = () => <Navigate to="/main" replace />;
